var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.readonly)?_c('span',[_vm._v(_vm._s(_vm.questionValue))]):(!_vm.notApplicable)?_c('TimePicker',{attrs:{"label":_vm.label,"disabled":_vm.readonly,"name":_vm.id,"rules":_vm.required ? {required: true} : {}},model:{value:(_vm.questionValue),callback:function ($$v) {_vm.questionValue=$$v},expression:"questionValue"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }